"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styledComponents = require("styled-components");

var _a = styledComponents,
    styled = _a.default,
    css = _a.css,
    createGlobalStyle = _a.createGlobalStyle,
    keyframes = _a.keyframes,
    ThemeProvider = _a.ThemeProvider;
exports.css = css;
exports.createGlobalStyle = createGlobalStyle;
exports.keyframes = keyframes;
exports.ThemeProvider = ThemeProvider;
exports.default = styled;